import MediaPlayer from "../MediaPlayer";
import m, {Vnode} from "mithril";
import {getPercentOffsetXFromEvent} from "../../../helpers"

export default class Volume {
    private static VALUES = [
        {i: 'mute', v: 0},
        {i: 'low', v: 0.15},
        {i: 'medium', v: 0.6},
        {i: 'high', v: 1},
    ];

    constructor(
        public readonly player: MediaPlayer
    ) { }

    public oncreate() {
        const storedVolume = window.localStorage?.getItem('volume');
        const volume = storedVolume ? Number(storedVolume) : 1;
        window.localStorage?.setItem('volume', ''+this.player.volume(volume));
        m.redraw();
    }


    public view(): Vnode|null {
        const volume = this.player.volume();
        if (volume === undefined) {
            return null; // volume is not supported
        }
        return m('div.control.control-volume', {}, [
            m(`i.icon.icon-volume-${this.getVolumeIconClass(volume)}.text-gray`, {
                onclick: (e: MouseEvent) => {
                    this.player.volume(this.player.volume() ? 0 : 1); // mute / unmute
                    window.localStorage.setItem('volume', ''+1);
                },
            }),
            m('.volume-slider', {
                title: (Math.round(volume*100))+'%',
                onclick: (e: MouseEvent) => {
                    const vol = getPercentOffsetXFromEvent(e)*1.1 - 0.05;
                    window.localStorage.setItem('volume', ''+this.player.volume(vol));
                },
            }, [
                m('.volume-slider-background', {}, [
                    m('.volume-slider-foreground',{
                        style: {
                            width: (volume*100)+'%',
                        }
                    }),
                ]),
            ]),
        ]);
    }

    private getVolumeIconClass(volume: number): string {
        for (const v of Volume.VALUES) {
            if (volume <= v.v) {
                return v.i;
            }
        }
        return 'high';
    }
}